import { format as formatFns, eachDayOfInterval, parseISO } from "date-fns";
import { fr, it, es, ro, enUS, de, ar } from "date-fns/locale";
import store from "@/store";

export const EPRO_DATE_FORMATS = Object.freeze({
  DDMMMYYYY: "dd MMM yyyy",
  DDMMMYYYY_HHMMA: "dd MMM yyyy hh mm a",
  YYYYMMDD: "yyyy-MM-dd",
  MMMYYYY: "LLLL yyyy",
});

export const WEEK_NUMBER = Object.freeze({
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
});

export const MONTHS = Object.freeze([
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]);

const dateLocales = {
  en: enUS,
  fr,
  de,
  es,
  it,
  ro,
  ar,
};

function getDateLocale() {
  const lang = store.getters["Language/language"];
  const code = lang ? lang.substring(0, 2).toLowerCase() : "en";
  return dateLocales[code] || dateLocales.en;
}

export function formatEproDate(date, dateFormatKey) {
  return formatFns(date, EPRO_DATE_FORMATS[dateFormatKey], {
    locale: getDateLocale(),
  });
}

export function formatDateToMonthDay(date) {
  return formatFns(date, "do MMM", { locale: getDateLocale() });
}

export function getWeekdayName(date, short = false) {
  return formatFns(new Date(date), short ? "EEE" : "EEEE", {
    locale: getDateLocale(),
  });
}

export function getMonthName(date, short = false) {
  return formatFns(new Date(date), short ? "MMM" : "MMMM", {
    locale: getDateLocale(),
  });
}

export function formatDateString(dateString, dateFormatKey) {
  const date = parseISO(dateString);
  return formatEproDate(date, dateFormatKey);
}

export function getDaysInterval(startDate, endDate) {
  return eachDayOfInterval({ start: startDate, end: endDate });
}

export function UTCStringToDate(utc) {
  const dateString = utc.split("T")[0];
  return parseISO(dateString);
}

export function convertSecondsToMinutes(seconds) {
  return Math.floor(seconds / 60);
}

export function isFutureDate(date) {
  return (
    new Date().setHours(0, 0, 0, 0) <
    new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
  );
}

export function isTodayOrFutureDate(date) {
  return (
    new Date().setHours(0, 0, 0, 0) <=
    new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
  );
}

export function isPastDate(date) {
  return (
    new Date().setHours(0, 0, 0, 0) >
    new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
  );
}

export function isTodayOrPastDate(date) {
  return (
    new Date().setHours(0, 0, 0, 0) >=
    new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
  );
}
